module.exports = __webpack_public_path__ + "static/img/yamamoto_06.15e9d31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/yamamoto_06.jpg
// module id = 6OxI
// module chunks = 0